import { HostListener, Input, OnChanges, SimpleChanges } from '@angular/core';
import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'timestamp-row',
  templateUrl: './timestamp-row.component.html',
  styleUrls: ['./timestamp-row.component.scss']
})
export class TimestampRowComponent implements OnInit, OnChanges {
  @Input() startDate: number | undefined;
  @Input() endDate: number | undefined;

  markerCount = window.innerWidth < 1000 ? 3 : 6;
  markers: number[] = [];

  ngOnInit() {
    this.generateMarkers();
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.generateMarkers();
  }

  private generateMarkers() {
    if (this.startDate === undefined || this.endDate === undefined) {
      this.markers = [];
      return;
    }

    const timeSpan = (this.endDate - this.startDate);
    const timeBetweenMarkers = timeSpan / this.markerCount;
    const markerTimes = [this.startDate];
    for (let i = 0; i < this.markerCount; i++) {
      markerTimes.push(markerTimes[i] + timeBetweenMarkers);
    }

    this.markers = markerTimes;
  }
}
